import { Component } from "react";

// One horizontal chip row, shared by every sheet (Moods, Skins, Settings,
// Feedback). The row never wraps: it scrolls sideways, shows a fade while
// there is more to reach, and — because the popup is usually driven by a
// plain mouse — turns a vertical wheel into horizontal scroll, which the
// browser only does on its own for horizontal gestures.
export default class ChipRow extends Component {
  constructor(props) {
    super(props);
    this.chipsRef = null;
    this.onWheel = (event) => this.handleWheel(event);
    this.state = { canScrollEnd: false };
  }

  componentDidMount() {
    this.updateScrollFade();
    this.resizeObserver = new ResizeObserver(() => this.updateScrollFade());
    if (this.chipsRef) {
      this.resizeObserver.observe(this.chipsRef);
      // Non-passive so the wheel can be redirected instead of scrolling the
      // sheet behind it; React's onWheel is passive and cannot preventDefault.
      this.chipsRef.addEventListener("wheel", this.onWheel, { passive: false });
    }
  }

  componentDidUpdate() {
    this.updateScrollFade();
  }

  componentWillUnmount() {
    this.resizeObserver?.disconnect();
    this.chipsRef?.removeEventListener("wheel", this.onWheel);
  }

  handleWheel(event) {
    const el = this.chipsRef;
    if (!el) return;
    if (el.scrollWidth <= el.clientWidth + 1) return;
    // A real horizontal gesture already works; only redirect vertical wheels.
    if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) return;

    const before = el.scrollLeft;
    el.scrollLeft = before + event.deltaY;
    if (el.scrollLeft !== before) event.preventDefault();
    this.updateScrollFade();
  }

  updateScrollFade() {
    const el = this.chipsRef;
    if (!el) return;
    const canScrollEnd =
      el.scrollWidth > el.clientWidth + 1 &&
      el.scrollLeft + el.clientWidth < el.scrollWidth - 2;
    if (canScrollEnd !== this.state.canScrollEnd) {
      this.setState({ canScrollEnd });
    }
  }

  render() {
    const { canScrollEnd } = this.state;

    return (
      <div
        className={`mood__chips-wrap${canScrollEnd ? " mood__chips-wrap--fade-end" : ""}`}
      >
        <div
          className="mood__chips"
          ref={(el) => {
            this.chipsRef = el;
            this.props.chipsRef?.(el);
          }}
          onScroll={() => this.updateScrollFade()}
        >
          {this.props.children}
        </div>
      </div>
    );
  }
}
